import api from 'api';

export const loadApplications = api(
  'GET /api/marketing-planning/fields/applications'
);

export const loadChannels = api(`GET /api/marketing-planning/fields/channels`);

export const loadPlatforms = api(
  'GET /api/marketing-planning/fields/platforms'
);

export const loadAffiliates = api(
  'GET /api/marketing-planning/fields/affiliates'
);

export const loadOwners = api('GET /api/marketing-planning/fields/owners');

export const loadCountries = api(
  'GET /api/marketing-planning/fields/countries'
);
export const loadManagers = api('GET /api/marketing-planning/fields/managers');
